const audioDescriptionButtonTemplate = ({accessBtnAudioDescription, audioDescriptionIndex}) => `<button class="audio-description-button ui control-button tertiary-button" name="AudioDescriptionButton" type="button" title="${accessBtnAudioDescription}" tabindex="${audioDescriptionIndex}" aria-pressed="false">
   <span class="ui audio-description-button-glyph"></span>
</button>`;

export default audioDescriptionButtonTemplate;
